import {Component, input} from '@angular/core'
import {Observable, of} from 'rxjs'
import {ImageThing} from '../../main/8-summary/summary.component'

/**
 * Class so that we can print charts dynamically.
 */

@Component({
  selector: 'spb-printable-chart',
  template: ''
})
export class PrintableChartComponent {

  public imageId = input<string>('')

  public print(): string {
    return 'not implemented'
  }

  public draw(): Observable<ImageThing> {
    return of({
      id: this.imageId(),
      image: this.print()
    })
  }
}
